import nav from './nav/nav';
import tabs from '../modules/tabs/tabs';
import svgInit from './svg/svgInit';
import pageLoad from './scrollTo/pageLoad';
import membershipPage from './membershipPage/membershipPage';
import colorSelect from './colorSelect/colorSelect.js';
import colorPicker from './colorPicker/colorPicker.js';
import logoEditor from './logoEditor/logoEditor.js';
import wysiwyg from './wysiwyg/wysiwyg';
import whitelabelSettings from './whitelabelSettings/whitelabelSettings';
import groupSettingsOther from './groupSettingsOther/groupSettingsOther';
import groupSettingsWhitelabelSettings from './groupSettingsWhitelabelSettings/groupSettingsWhitelabelSettings';
import groupSettingsShareLinkSettings from './groupSettingsShareLinkSettings/groupSettingsShareLinkSettings';
import groupSettingsPermissions from './groupSettingsPermissions/groupSettingsPermissions';
import shareLinkSettings from './shareLinkSettings/shareLinkSettings';
import pagination from './pagination/pagination';
import rcpForm from './forms/rcpForm';
import cleanUrl from './cleanUrl/cleanUrl';
import groupSettingsAll from './groupSettingsAll/groupSettingsAll';
import accordian from './accordian/accordian';
import integrations from './integrations/integrations';
import groupSettings from './groupSettings/groupSettings';
import advancedSettings from './advancedSettings/advancedSettings';
import sharedLinks from './sharedLinks/sharedLinks';

export const settings = (): void => {
	nav();
	tabs();
	svgInit();
	pageLoad();
	membershipPage();
	colorSelect(['pdf-generator-color-set', 'group-settings-pdf-color-set']);
	colorPicker();
	logoEditor(['pdf-generator-logo', 'group-settings-pdf-logo']);
	wysiwyg();
	whitelabelSettings();
	groupSettingsOther();
	groupSettingsWhitelabelSettings();
	groupSettingsShareLinkSettings();
	groupSettingsPermissions();
	shareLinkSettings();
	pagination();
	rcpForm();
	cleanUrl();
	groupSettingsAll();
	accordian();
	integrations();
	groupSettings();
	advancedSettings();
	sharedLinks();
};
